exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.jira-logo-white[data-v-0082362d] svg path {\n  fill: white;\n}\n", ""]);

